import{messages as s}from"./translations/sk";import{messages as m}from"./translations/en";import{messages as o}from"./translations/cs";import{messages as a}from"./translations/hu";const p={sk:s,en:m,cs:o,hu:a};export{p as translations};
